import { atom } from 'jotai';

import { SearchTreeBuilderState } from './SearchTreeBuilder';

export const debugAtom = atom(false);
export const searchTreeBuilderStateAtom = atom<SearchTreeBuilderState | undefined>(undefined);


/** Maps widget instance id (from `useId`) to whether that instance's date filter is invalid. */
export const advancedSearchDateFilterInvalidAtom = atom<Record<string, boolean>>({});
